import React, { useState } from "react";
import {
    AccountingReportType,
    ACCOUNTING_REPORT_LABELS,
} from "@common/types/reports/report-type";
import { Drawer } from "@design-system/Drawer/Drawer";
import { LocalAccountingTabProvider } from "@components/accounting/LocalAccountingTabProvider";
import { AccountingReportFilters } from "@components/accounting/types";
import { ArAgingBucket } from "@common/types/reports/ar-aging";
import { ArAgingDetailReport } from "./ArAgingDetailReport";

interface ContentProps {
    initialFilters: AccountingReportFilters;
    initialBuckets?: ArAgingBucket[];
}

const ArAgingDetailDrawerContent: React.FC<ContentProps> = ({
    initialFilters,
    initialBuckets,
}) => {
    const [buckets, setBuckets] = useState<ArAgingBucket[] | undefined>(
        initialBuckets,
    );

    return (
        <LocalAccountingTabProvider initialFilters={initialFilters}>
            <ArAgingDetailReport
                buckets={buckets}
                onBucketsChange={setBuckets}
                showGoToInvoices
            />
        </LocalAccountingTabProvider>
    );
};

interface Props {
    open: boolean;
    onClose: () => void;
    filters: AccountingReportFilters;
    buckets?: ArAgingBucket[];
}

export const ArAgingDetailDrawer: React.FC<Props> = ({
    open,
    onClose,
    filters,
    buckets,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const shouldRender = isOpen || open;

    return (
        <Drawer
            open={open}
            onClose={onClose}
            direction="right"
            size="fullScreenWithNav"
            onAnimationEnd={setIsOpen}
            headerAddonLeft={
                ACCOUNTING_REPORT_LABELS[AccountingReportType.AR_AGING_DETAIL]
            }
            noPadding
        >
            {shouldRender && (
                <ArAgingDetailDrawerContent
                    initialFilters={filters}
                    initialBuckets={buckets}
                />
            )}
        </Drawer>
    );
};
